import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION } from "@lib/shared_constants";

export interface WorkflowAttributeAllowedValue {
  value: string;
  description: string;
}

export type WorkflowAttributeDataType = SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION["DATA_TYPES"][number];

export interface WorkflowAttributeDefinitionResultObject {
  id: string;
  type: "workflow_attribute";
  name: string;
  description: string;
  data_type: WorkflowAttributeDataType;
  allowed_values: WorkflowAttributeAllowedValue[];
  created_at: string;
  updated_at: string;
  created_by_email: string;
}

export type ConversationalToolDefinitionResultObject = WorkflowAttributeDefinitionResultObject;

export interface ConversationalToolDefinitionIdResult {
  result: ConversationalToolDefinitionResultObject;
}

export interface GetConversationalToolDefinitionIdProps {
  type: "workflow_attribute";
  appGroupId: string;
  definitionId: string;
}

export interface UpdateWorkflowAttributeDefinitionIdProps {
  type: "workflow_attribute";
  appGroupId: string;
  definitionId: string;
  description: string;
  allowedValues: WorkflowAttributeAllowedValue[];
}

export type UpdateConversationalToolDefinitionIdProps = UpdateWorkflowAttributeDefinitionIdProps;

export interface DeleteConversationalToolDefinitionIdProps {
  type: "workflow_attribute";
  appGroupId: string;
  definitionId: string;
}

export type UpdateConversationalToolDefinitionIdErrors =
  | FetchUserEncodedError<SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION["ERROR_CODES"]["INVALID_DESCRIPTION"]>
  | FetchUserEncodedError<SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION["ERROR_CODES"]["INVALID_ALLOWED_VALUES"]>;

export const isUpdateConversationalToolDefinitionIdError = (
  error: FetchRequestError
): error is UpdateConversationalToolDefinitionIdErrors => {
  return error instanceof FetchUserEncodedError;
};

export type DeleteConversationalToolDefinitionIdErrors = FetchUserEncodedError<
  SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION["ERROR_CODES"]["DELETE_IN_USE"]
>;

export const isDeleteConversationalToolDefinitionIdError = (
  error: FetchRequestError
): error is DeleteConversationalToolDefinitionIdErrors => {
  return error instanceof FetchUserEncodedError;
};
